import React, {forwardRef, ReactNode} from 'react'
import MaskedInput from 'react-text-mask'

interface CardKeyFacilityNumberMaskProps {
    inputRef: (ref: HTMLInputElement | null) => void;
}

export class CardKeyFacilityNumberMask extends React.PureComponent<CardKeyFacilityNumberMaskProps> {
    render(): ReactNode {
        const {inputRef, ...other} = this.props

        return (
            <MaskedInput
                {...other}
                // render={
                //     (ref: any) => {
                //         inputRef(ref ? ref.inputElement : null)
                //     }}
                mask={[/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                placeholderChar={'\u2000'}
                showMask
            />
        );
    }
}
